<template>
  <div v-if="!keyId && !chatMsgs" class="chat-field">
    <md-content
      class="unselected-notice"
      data-mcs-theme="dark"
      ref="chatBox"
      id="chat-field-thread-unselected"
    >
      <span class="notice title">Select a conversation</span>
    </md-content>
  </div>
  <div v-else>
    <div class="chat-field selected-conversation">
      <div v-if="!partner && chatMsgs.type === 'MY_ITEM_MESSAGE'" class="partner-box">
        <img class="header-item-image" @click="checkRoute()" :src="getItemImagePath(chatMsgs.key)" alt="Item" />
        <div class="header-box-text">
          <p class="header-box-title" @click="checkRoute()"> {{ chatMsgs.key.title }}</p>
          <p class="header-subtitle"> {{ headerText }} you at {{ timeAgo }}</p>
        </div>
      </div>
      <div v-if="partner && chatMsgs.type === 'USERS_ITEM_MESSAGE'" class="partner-box">
        <img class="header-item-image" @click="checkRoute()" :src="getItemImagePath(chatMsgs.key)" alt="Item" />
        <div class="header-box-text">
          <p class="header-box-title" @click="checkRoute()"> {{ chatMsgs.key.title }}</p>
          <p class="header-subtitle"> {{ headerText }} {{ partner.firstName }} at {{ timeAgo }}</p>
        </div>
      </div>
      <div v-if="partner && chatMsgs.type === 'MY_ITEM_MESSAGE'" class="partner-box">
        <md-button
          v-if="!hasPartner"
          class="md-icon-button back-button"
          @click="backButton"
        >
          <md-icon>arrow_back</md-icon>
        </md-button>
        <div class="header-partner" :class="{ 'pl-2': hasPartner }">
          <SUserAvatar
            :myUser="partner"
            size="x-medium"
            :isProfileAvatar="false"
          />
          <router-link :to="`/s-app/profile-page/${partner.id}`">
            <span class="header-box-title title pl-1 pr-2">{{
              partner.username
            }}</span>
          </router-link>
        </div>
      </div>

      <div v-if="(chatMsgs.type === 'MY_GROUP_MESSAGE' || chatMsgs.type === 'MY_MODERATOR_GROUP_MESSAGE')" class="partner-box">
        <img class="header-group-image" @click="checkRoute()" :src="getGroupImagePath(chatMsgs.key)" alt="Group" />
        <div class="header-box-text">
          <p class="header-box-title" @click="checkRoute()"> {{ chatMsgs.key.name }}</p>
          <p class="header-subtitle">  {{ numberOfMembers }} | Moderator: {{ moderatorName }} </p>
        </div>
      </div>

      <div v-if="(chatMsgs.type === 'MY_GARAGE_MESSAGE' || chatMsgs.type === 'USERS_GARAGE_MESSAGE')" class="partner-box">
        <img class="header-group-image" @click="checkRoute()" :src="require('@/assets/garage.jpg')" alt="Garage" />
        <div class="header-box-text">
          <p class="header-box-title" @click="checkRoute()"> {{ chatMsgs.key.garageName }}  {{ garageDates }} </p>
          <div class="header-box-subtitle">
            <p class="header-subtitle">Sale hosted by {{ chatMsgs.key.owner }}   </p>
            <p class="ended-sale" v-if="isEndDatePassed(chatMsgs.key.endDate)">  (this sale has ended)</p>
          </div>
        </div>
      </div>

      <md-content
        class="md-scrollbar p-1"
        :class="[{ 'locked-chat': !partner }]"
        data-mcs-theme="dark"
        ref="chatBox"
        id="chat-field-thread"
      >
        <span class="conversation-start">The conversation starts here</span>
        <span class="conversation-start conversation-start-date">{{ timeAgo }}</span>

        <ul class="notification-list chat-message chat-message-field">
          <div class="time-chat mt-3" v-if="msgCounter > 0">
            <a
              href="#"
              class="h5"
              style="text-align: center"
              @click="showMoreMsgs"
              >Click to show more</a
            >
          </div>


          <div v-if="partner && (chatMsgs.type === 'USERS_ITEM_MESSAGE' || chatMsgs.type === 'MY_ITEM_MESSAGE')" class="partner-chat-item-info" >
            <div class="partner-chat-box">
              <md-icon :class="tradeType">autorenew </md-icon>
              <div class="partner-chat-box-title">
                <span class="partner-item-info-header">{{ tradeType }}</span>
                <span :class="tradeType">"{{ chatMsgs.key.title }}"</span>
              </div>
            </div>
          </div>

          <li
            v-for="(message, index) in filteredChat"
            :key="message.id"
            :class="[
              'box-container',
              { 'align-box-right': loggedUser.id === message.senderId },
            ]"
          >
            <span v-if="isSameDayAsLastMessage(message, index)"
            class="conversation-start conversation-start-date">{{ messageDay }}</span>
            <div class="notification-event" :class="[{ 'user-message':  loggedUser.id !== message.senderId }]" data-cy="message-content">
              <div
                v-if="loggedUser.id !== message.senderId && !partner"
                @click="selectPartner(message.sender)"
              >
                <div class="pl-3 pb-1 pt-1">
                  <SUserAvatar
                    :myUser="message.sender"
                    size="message-user"
                    :isProfileAvatar="false"
                  />
                </div>
              </div>
              <div
                :class="[
                  'text-break chat-box file',
                  { 'current-user': loggedUser.id === message.senderId },
                ]"
                style="cursor: pointer"
                v-if="message.type === 'FILE'"
                @click="getFile(message.msg)"
              >
                <div>
                  <div class="text-center">
                    <img :src="getChatImage(message.msg)" id="chat-message" alt="Image"/>
                  </div>
                  <p>{{ message.msg | fileName }}</p>
                  <span class="message-received-hour title">
                    {{ getOnlyTimeText(message) }}
                  </span>
                </div>
                <md-tooltip
                  class="tooltip-message"
                  :md-direction="tooltipDirection(message)"
                >
                  <div
                    class="tooltip-arrow"
                    :class="tooltipDirection(message)"
                  ></div>
                  {{ getDateText(message) }}
                  <p class="mb-0 text bold">
                    {{ message.sender.username }}
                  </p></md-tooltip
                >
              </div>

              <div
                :class="[
                  'text-break chat-box',
                  { 'current-user': loggedUser.id === message.senderId },
                ]"
                v-else
                @click="selectPartner(message.sender)"
              >
                <div id="chat-message-box">
                  <router-link :to="`/s-app/profile-page/${message.sender.id}`">
                    <p class="sender-name title pl-1 pr-2"
                      v-if="loggedUser.id !== message.senderId">
                      {{ message.sender.username }}
                    </p>
                  </router-link>
                  <p class="sender-name title pl-1 pr-2 own-message-title"
                    v-if="(loggedUser.id == message.senderId) && !partner">
                    {{ ownMsgHeaderText }} {{ message.receiver.username }}
                  </p>
                  <p class="sender-name title pl-1 pr-2 own-message-title"
                    v-if="(loggedUser.id == message.senderId) && partner">
                      You
                  </p>
                  <p v-if="loggedUser.id !== message.senderId"></p>
                  <p>{{ message.msg }}</p>
                </div>
                <span class="message-received-hour title">
                  {{ getOnlyTimeText(message) }}
                </span>
                <md-tooltip
                  class="tooltip-message"
                  :md-direction="tooltipDirection(message)"
                >
                  <div
                    class="tooltip-arrow"
                    :class="tooltipDirection(message)"
                  ></div>
                  {{ getDateText(message) }}
                </md-tooltip>
              </div>
            </div>
          </li>
        </ul>
      </md-content>
      <div class="form-group label-floating form-border-unpartner" v-if="!partner">
        <p class="bottom-box-main-text notice">
          Click on any conversation to open the private chat
        </p>
        <p class="bottom-box-secondary-text title">
          (Only you can see this chat)
        </p>
      </div>
      <form v-else class="chat-form">
        <div
          :class="[
            'form-group label-floating form-border ',
            { 'is-empty is-focused': text === '' },
          ]"
          @keyup.enter="send"
          @paste="pasteFile"
        >
          <div class="write-message-area">
            <div class="text-area">
              <TextArea
                :cssClass="['remove-border-text-area']"
                v-model="text"
                :disabled="isSending"
                ref="chatInput"
                data-cy="textarea-center"
                max=360
                placeholder="Type here... (max: 360 characters)"
                @mounted="focusInput()"
              />
            </div>
            <div class="btn-reply">
              <SButtonMaterial
                buttonType="button"
                class="mt-3 send-button"
                color="tertiary"
                textColor="white"
                materialClass="dense"
                text="Send"
                iconRightText="send"
                iconColor="white"
                @button="send"
                :disabled="isSending || !text"
                data-cy="chat-send"
              />
              <div class="chat-emoji">
                <ChatEmoji
                  :disabled="isSending"
                  @emoji="setEmojiMsg"
                  @file="setAttachment"
                />
              </div>
            </div>
          </div>
          <LoadingSpinner position="absolute" v-if="isSending" />
        </div>
      </form>
    </div>
  </div>
  <!-- ... end Window-popup-CHAT for responsive min-width: 768px -->
</template>

<script>
import TextArea from "@/components/atoms/TextArea";
import UserHelperVue from "../../mixins/UserHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import linkify from "vue-linkify";
import formatISO from 'date-fns/formatISO';
import Vue from "vue";
import ChatEmoji from "@/components/atoms/ChatEmoji";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";

Vue.directive("linkified", linkify);

import moment from "moment";

export default {
  name: "SChatThread",
  components: {
    TextArea,
    ChatEmoji,
    SButtonMaterial,
    SUserAvatar,
    LoadingSpinner,
  },
  props: {
    chatMsgs: Object,
    keyId: Number,
    hasPartner: Boolean,
    userFromTab: Object,
  },
  mixins: [UserHelperVue, ChatHelperVue, ItemHelperVue, GroupHelperVue],
  data() {
    return {
      isSending: false,
      text: "",
      payload: {},
      file: [],
      limiter: 10,
      breakScroll: true,
      userId: null,
      partner: null,
      messageDay: "",
    };
  },
  computed: {
    users() {
      let users = [];
      if (this.chatMsgs) {
        this.chatMsgs.messages.forEach((element) => {
          if (
            element.receiverId !== this.loggedUser.id &&
            !users.find((user) => user.id === element.receiverId)
          ) {
            users.push(element.receiver);
          }
          if (
            element.senderId !== this.loggedUser.id &&
            !users.find((user) => user.id === element.senderId)
          ) {
            users.push(element.sender);
          }
        });
      }
      return users;
    },
    chatTitle() {
      let title = "";
      if (this.chatMsgs.type === "MY_ITEM_MESSAGE") {
        this.users.forEach((user, index) => {
          title += "<span class='title'> @" + user.username + "</span>";
          if (index < this.users.length - 1) title += ", ";
          else title += " ";
        });
        title +=
          "<span class='" +
          this.transactionType +
          "'>" +
          this.transactionType +
          "</span";
      } else if (this.chatMsgs.type === "USERS_ITEM_MESSAGE") {
        title +=
          "You " +
          "<span class='" +
          this.transactionType +
          "'>" +
          this.transactionType +
          "</span>";
        title += "<span class='title'> @" + this.users[0].username + "</span>";
      } else if (this.chatMsgs.type === "USERS_GARAGE_MESSAGE" || this.chatMsgs.type === "MY_GARAGE_MESSAGE") {
        title += "<span class='title'> You send a message to @" + this.users[0].username + "</span>";
      }
      else {
        title +=
          '<span class="' +
          this.getGroupPrivacy(this.chatMsgs.key) +
          '">' +
          this.getGroupPrivacy(this.chatMsgs.key) +
          "</span> group - <span class='title'> Moderator is ";
      }
      if (this.chatMsgs.type === "MY_GROUP_MESSAGE") {
        title += "@" + this.partner.username;
      } else if (this.chatMsgs.type === "MY_MODERATOR_GROUP_MESSAGE") {
        title += "You </span>";
      }

      return title;
    },
    transactionType() {
      if (
        this.chatMsgs.type === "MY_ITEM_MESSAGE" ||
        this.chatMsgs.type === "USERS_ITEM_MESSAGE"
      ) {
        if (this.chatMsgs.key.type === 3 || this.chatMsgs.key.type === 1) {
          return "requested";
        } else {
          return "offered";
        }
      }
      return "";
    },
    tradeType() {
      if (this.chatMsgs.key.type === 3 || this.chatMsgs.key.type === 1) {
        return "Requesting";
      } else {
        return "Offering";
      }
    },
    moderatorName() {
      if (this.chatMsgs.messages[0].receiver.id === this.loggedUser.id) {
        return this.chatMsgs.messages[0].sender.firstName;
      }
      return this.chatMsgs.messages[0].receiver.firstName;
    },
    numberOfMembers() {
      if (this.chatMsgs.membersCount === 1)
      return this.chatMsgs.membersCount + " member";
      return this.chatMsgs.membersCount + " members";
    },
    msgCounter() {
      let msgCount = 0;
      let msgsArray = [];
      const currentMsgs = this.getChatMessages(this.user.id, this.limiter);
      if(this.userMessages.length > 0 && currentMsgs.length > 0){
        msgsArray = this.userMessages.find(
          (user) => this.user.id === user.id
        ) ?? [];
        msgCount = msgsArray.messages.length - currentMsgs.length;
      }
      return msgCount;
    },
    filteredChat() {
      if (!this.partner) {
        return this.chatMsgs.messages;
      }
      let filterMsgs = [];
      filterMsgs = this.chatMsgs.messages.filter((msg) => {
        return (
          msg.receiverId === this.partner.id || msg.senderId === this.partner.id
        );
      });
      return filterMsgs;
    },
    ownMsgHeaderText() {
      return "You <-> ";
    },
    headerText(){
      switch (this.chatMsgs.key.type) {
        case 1:
          return "Item offer posted by";
        case 2:
          return "Item request posted by";
        case 3:
          return "Item offer posted by";
        case 4:
          return "Item request posted by";
        default:
          return "";
      }
    },
    garageDates() {
      const dateStart = new Date(this.chatMsgs.key.startDate);
      const dateEnd = new Date(this.chatMsgs.key.endDate);
      let startDate = formatISO(dateStart, { representation: 'date' });
      let endDate = formatISO(dateEnd, { representation: 'date' });
      let result = "(" + startDate.slice(5) + " to " + endDate.slice(5) + ")";
      return result;
    },
    timeAgo() {
      const date = new Date(this.chatMsgs.key.createdAt);
      return date.toLocaleString('en-us', { dateStyle: 'short' });
    },
  },
  watch: {
    keyId(newValue) {

      if (newValue !== this.userId) {
        this.limiter = 10;
      }
      this.partner = null;
      if (this.hasPartner) {
        this.selectPartner(this.users[0]);
      } else if (this.hasPartner && this.userFromTab) {
        this.selectPartner(this.userFromTab);
      }
    },
    text(newValue) {
      this.$parent.$parent.$parent.$parent.$parent.saveChatInput(
        this.keyId,
        newValue
      );
      this.$parent.$parent.$parent.$parent.$parent.$refs[this.chatMsgs.type+"-"+this.keyId][0].saveDraft(newValue);
    },
  },
  methods: {
    backButton() {
      this.partner = null;
    },
    checkRoute() {
      if (this.chatMsgs.type === "MY_ITEM_MESSAGE" || this.chatMsgs.type === "USERS_ITEM_MESSAGE"){
        this.$router.push(`/s-app/item-details/${this.chatMsgs.key.id}`);
      } else if (this.chatMsgs.type === "MY_GROUP_MESSAGE" || this.chatMsgs.type === "MY_MODERATOR_GROUP_MESSAGE") {
        this.$router.push(`/s-app/group-page/${this.chatMsgs.key.id}`);
      } else if (this.chatMsgs.type === "MY_GARAGE_MESSAGE" || this.chatMsgs.type === "USERS_GARAGE_MESSAGE"){
        localStorage.setItem("garageSale", JSON.stringify(this.chatMsgs.key));
        this.$router.push(`/s-app/garage-sales-detail/${this.chatMsgs.key.id}`);
      }
    },
    selectPartner(user) {
      this.partner = user;
      this.$nextTick(() => {
        this.focusInput();
      });
    },
    recoveryText(rText) {
      this.text = rText;
    },
    showMoreMsgs() {
      this.userId = this.userChatId;
      this.limiter += 5;
      this.breakScroll = false;
    },
    pasteFile(event) {
      this.retrieveImageFromClipboard(event, (imageFile) => {
        this.setAttachment(imageFile);
      });
    },
    async send() {
      this.isSending = true;
      this.payload = {
        ...this.filteredChat[0],
        receiver: this.partner,
        sender: this.loggedUser,
      };
      this.payload.msg = this.text;
      if (
        this.chatMsgs.type === "USERS_ITEM_MESSAGE" ||
        this.chatMsgs.type === "MY_ITEM_MESSAGE"
      ) {
        await this.postUserItemMessage({
          message: this.payload,
          partner: this.partner.id,
          item: this.keyId,
          postMsg: this.text,
        });
      } else if(
            this.chatMsgs.type === 'USERS_GARAGE_MESSAGE' ||
            this.chatMsgs.type === 'MY_GARAGE_MESSAGE'
        ) {
            await this.postGarageUserMessage({
              message: this.payload,
              partner: this.partner.id,
              garage: this.keyId,
              postMsg: this.text,
            });

      }else {
        await this.postUserGroupMessage({
          message: this.payload,
          partner: this.partner.id,
          group: this.keyId,
          postMsg: this.text,
        });
      }

      this.cleanInputField();
      this.fetchUserMessages();
      this.$nextTick(() => {
        this.focusInput();
      });
    },
    scrollToBottom() {
      this.$refs.chatBox.$el.scrollTop = this.$refs.chatBox.$el.scrollHeight;
    },
    async setAttachment(f) {
      this.isSending = true;
      this.payload = this.chatMsgs.messages[0];
      this.file = f[0];
      if (
        this.chatMsgs.type === "USERS_ITEM_MESSAGE" ||
        this.chatMsgs.type === "MY_ITEM_MESSAGE"
      ) {
        await this.sendItemAttachment({
          message: this.payload,
          partner: this.partner.id,
          item: this.keyId,
          file: this.file,
          newChat: false,
        });
      } else {
        await this.sendGroupAttachment({
          message: this.payload,
          partner: this.partner.id,
          group: this.keyId,
          file: this.file,
          newChat: false,
        });
      }
      this.isSending = false;
      this.fetchUserMessages();
      this.$nextTick(() => {
        this.focusInput();
      });
    },
    async getFile(file) {
      if (file) {
        if (!file.includes("Error")) {
          let fileName = file.substring(file.lastIndexOf("/") + 1);
          let blob = await this.fetchAttachment({ fileName: fileName });
          const fileURL = URL.createObjectURL(blob);

          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = fileURL;
          a.download = fileName;
          a.click();
          URL.revokeObjectURL(fileURL);
        }
      }
    },
    isSameDayAsLastMessage(msg, index) {
      if (index === 0) return false;
      
      let currentMsgs = this.filteredChat;
      let currentMsgDate = msg.createdAt;
      let lastMsgDate = currentMsgs[index - 1].createdAt;
      let isDifferentDay = moment(currentMsgDate).isAfter(lastMsgDate, "day");
      const date = new Date(currentMsgDate);
      this.messageDay = date.toLocaleString('en-us', { dateStyle: 'short' });

      return isDifferentDay;
    },
    tooltipDirection(message) {
      return this.loggedUser.id === message.senderId ? "left" : "right";
    },
    getDateText(msg) {
      const date = this.$options.filters.dateLong(msg.createdAt);
      const time = this.$options.filters.time(msg.createdAt);
      return `${date} ${time}`;
    },
    getOnlyDateText(msg) {
      const date = this.$options.filters.dateLong(msg.createdAt);
      return `${date}`;
    },
    getOnlyTimeText(msg) {
      const time = this.$options.filters.time(msg.createdAt);
      return `${time}`;
    },
    focusInput() {
      if(this.partner){
        this.$refs.chatInput.focus();
      }
    },
    setEmojiMsg(emoji) {
      this.$refs.chatInput.focus();
      this.text += String.fromCodePoint(emoji);
    },
    cleanInputField() {
      this.text = "";
      this.payload = {};
      this.isSending = false;
    },
    isEndDatePassed(endDate) {
      const currentDate = new Date();
      const garageEndDate = new Date(endDate);
      garageEndDate.setDate(garageEndDate.getDate() + 1);
      return garageEndDate < currentDate;
    },
  },
  mounted() {
    setTimeout(() => {
      this.scrollToBottom();
    }, 500);
  },
  updated() {
    if (this.breakScroll) {
      this.scrollToBottom();
    } else {
      this.breakScroll = false;
    }
    $("[data-toggle='tooltip']").tooltip();
  },
};
</script>

<style>
  .text-area .mb-3 {
    height: 100% !important;
    margin-bottom: 0 !important;
  }

  .text-area .mb-3 div {
    height: 100% !important;
  }
  .text-area .mb-3 div textarea {
    height: 100% !important;
    overflow-y: scroll;
    min-height: unset;
    padding: 0.5rem !important;
  }
</style>

<style lang="scss" scoped>

.write-message-area {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;

}
.title-color {
  color: $dark !important;
}
.offered {
  color: $offer !important;
}
.requested {
  color: $request !important;
}
.Public {
  color: $primary;
}
.ended-sale {
  font-size: 12px;
  line-height: 12px;
  margin: 10px 0 10px 5px;
  color: red;
}
.Private {
  color: $danger;
}
textarea {
  min-height: 112px;
}
.label-floating textarea.form-control {
  padding-top: 2rem;
}
.title {
  font-style: normal;
  font-weight: 400;
  line-height: 8px;
  letter-spacing: 1.25px;
}
.own-message-title {
  display: flex;
}
.header-box-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  line-height: 6px;
  margin: 8px;
}
.header-box-title {
  font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    margin: 0;
    color: black;
    cursor: pointer;
}
.conversation-start{
  display: flex;
  justify-content: center;
  margin-top: 6px;
  color: dimgray;
  font-size: 16px
}
.conversation-start-date {
  font-size: 12px;
}
.header-subtitle {
  font-size: 12px;
  line-height: 12px;
  margin: 10px 0 10px 5px;
  color: dimgray;
}
.header-box-subtitle {
  display: flex;
}
.header-partner {
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
}
.header-item-image {
  height: 90%;
  cursor: pointer;
}
.header-group-image {
  height: 70%;
  cursor: pointer;
}
.transaction-request {
  color: $tertiary;
}
#chat-message {
  max-width: 200px;
  max-height: 100px;
}
#chat-field-thread {
  overflow: auto !important;
  height: 65%;
  max-height: 100%;
  background-color: #f4f4f4;
}
.locked-chat {
  height: 65% !important;
}
.form-border {
  border-top: 2px solid rgba(0, 0, 0, 0.12);
  text-align: center;
  height: 76%;
  border-radius: 8px;
}
.form-border-unpartner {
  border-top: 2px solid rgba(0, 0, 0, 0.12);
  text-align: center;
  height: 17%;
  border-radius: 8px;
}
.usr-img-thumb {
  height: 34px;
  width: 34px;
}

.spinner-border {
  position: absolute;
  top: 50px;
  right: 420px;
}

.btn-reply {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.row {
  flex-direction: row;
  border-style: solid;
  border-width: thin;
  border-color: #888da8;
  left: 15px;
}

.text-area {
  max-width: 80%;
  height: 100%;
  max-height: 100px;
  flex: 1;
  margin: 0 5px;
  background: white;
  text-align: center;
  font-size: 1.5em;
}
.char-counter {
  display: flex;
  justify-content: flex-end;
  opacity: 0.7;
}
.add-options-message {
  padding: 0;
}
.chat-emoji {
  margin-right: 0.8em;
}
.remove-border-text-area {
  border: none !important;
}
.container {
  .row {
    border: none !important;
  }
}
</style>

<style lang="scss" scoped>
.ui-block-title {
  max-height: 5%;
  display: flex;
  align-items: center;
  padding: 10px 10px 0 10px;
  border-bottom: unset;
}
.chat-field {
  border-radius: 5px;
  border: 2px solid $grey-light !important;
  /* height: 35.5rem; */
}

.selected-conversation {
  height: 100%;
}

.box-container {
  padding-top: 0px;
  padding-bottom: 4px;
}
.partner-chat-item-info {
  padding: 0 15px 0 15px;
  margin-bottom: -24px;
  width: 40%;
}
.align-box-right {
  text-align: right;
  margin-top: 24px;
}

.time-chat {
  margin-top: 4em;
  margin-bottom: 1em;
  text-align: center;
  display: block;
}
.send-button {
  border-radius: 20px;
  margin-bottom: 0.5rem;
}
.hidden {
  display: none;
}
.partner-chat-box {
  background:#C2C2C2;
  color: white;
  width: 100%;
  font-weight: bold;
  font-size: 1.2em;
  padding: 0.5em 0.5em;
  border-radius: 20px 20px 0px 0px;
  border-color: dimgray;
  border-style: solid;
  display: flex;
  flex-direction: row;
}
.partner-chat-box-title {
  display: flex;
  flex-direction: column;
  width: 85%;
}
.partner-item-info-header {
  color: dimgray;
}
.Requesting {
  color: #395693 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}
.Offering {
  color: #6DA34D !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-box {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    #939393;
  color: white;
  width: fit-content;
  font-weight: bold;
  font-size: 1.2em;
  padding: 0.8em 1.2em;
  border-radius: 0px 20px 20px 0px;

  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */

  &.current-user {
    background-color: $tertiary;
    border-radius: 20px 4px 12px 20px;
  }
  &.current-user.file {
    background-color: $tertiary;
    border-radius: 10px 10px 0px 50px;
  }
  &.file {
    border-radius: 10px 10px 50px 0px;
  }
}
.message-received-hour {
  margin: 0.4em 0 0 1em;
  display: block;
  font-size: 10px;
  text-align: end;
}
.md-content {
  max-height: 450px;
  overflow: auto;
}
.unselected-notice {
  text-align: center;
  padding-top: 16rem;
}
.notice {
  font-size: 14px;
  line-height: 16px;
  color: $black;
}
.bottom-box-main-text {
  opacity: 0.78;
  margin-top: 0.5rem;
}
.bottom-box-secondary-text {
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  color: $black;
  opacity: 0.48;
}
.sender-name {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: $yellow-user;
}
#chat-message-box p {
  margin-bottom: 0.1rem;
}
.md-avatar.md-small {
  width: 36px !important;
  height: 36px !important;
  font-size: 17px;
}
.sender-box {
  background: rgba(118, 118, 118, 0.4);
  border: 2px solid #767676;
  width: fit-content;
  border-radius: 12px 20px 12px 0px;
  cursor: pointer;
}
.partner-box {
  height: 18%;
  background: $white;
  border: 2px solid #c4c4c4;
  width: 100%;
  border-radius: 4px 4px 8px 8px;
  display: flex;
  align-items: center;
}
.grey-bar {
  width: 8px;
  height: 40px;
  position: absolute;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    $dark;
  border-radius: 0px 10px 10px 0px;
  transform: matrix(-1, 0, 0, 1, 3, 3);
}
.back-button i {
  color: $tertiary !important;
}
.back-button {
  margin-right: 0;
}
.tooltip-message {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.25px;
  color: rgba(0, 0, 0, 0.8) !important;
  background: $grey !important;
  border-radius: 4px;
  display: inline-table;
  padding: 8px;
  margin-left: 5px;
}
.tooltip-arrow.right {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-right: 10px solid $grey;
  border-bottom: 5px solid transparent;
  position: absolute;
  top: 12px;
  left: -8px;
}
.tooltip-arrow.left {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-left: 10px solid $grey;
  border-bottom: 5px solid transparent;
  position: absolute;
  top: 12px;
  right: -8px;
}

.user-message {
  margin-top: 2em;
  display: flex !important;
}
</style>
